// API related actions
export const FETCHING_TRANSPORTS_LIST = '@@toyota/FETCHING_TRANSPORTS_LIST';
export const FETCHED_TRANSPORTS_LIST = '@@toyota/FETCHED_TRANSPORTS_LIST';
export const FETCHED_TRANSPORTS_LIST_FAILED = '@@toyota/FETCHED_TRANSPORTS_LIST_FAILED';
